// extracted by mini-css-extract-plugin
export var marginNegative = "_7h-5 _7h-3 _7h-1";
export var marginPositive = "_7h-4 _7h-3 _7h-1";
export var modalContent = "_7h-6";
export var samplesTable = "_7h-8";
export var samplesTableContainer = "_7h-7";
export var statBox = "_7h-a";
export var tableCell = "_7h-1";
export var tableCellCenter = "_7h-2 _7h-1";
export var tableCellRight = "_7h-3 _7h-1";
export var tableHeader = "_7h-0";
export var trackingNumber = "_7h-9";